import { useQuery } from '@apollo/client';
import { gql } from '~/apollo/client-v3';
import type { FieldProps } from 'formik';
import * as R from 'ramda';
import React from 'react';

import * as fragments from '~/apollo/fragments';
import type { FormationListSelectorQuery } from '~/apollo/generated/v3/graphql';
import { FormikReactSelectField } from '~/components/common/FormikField/FormikReactSelectField';

const FORMATION_LIST_SELECTOR = gql`
  query FormationListSelector {
    lithostratFormationList {
      ...lithostratFormationParts
      lithostratType {
        ...lithostratTypeParts
      }
      wikiPage {
        ...lithostratWikiPageParts
      }
    }
  }

  ${fragments.lithostratFormationParts}
  ${fragments.lithostratTypeParts}
  ${fragments.lithostratWikiPageParts}
`;

type Props = FieldProps & {
  lithostratTypeId?: number;
  disabled?: boolean;
  onlyPublished?: boolean;
};

export function FormationSelector({
  lithostratTypeId,
  onlyPublished = false,
  ...props
}: Props) {
  const { loading, data } = useQuery<FormationListSelectorQuery>(
    FORMATION_LIST_SELECTOR,
    {},
  );

  const fmList = data?.lithostratFormationList ?? [];
  const filtered = lithostratTypeId
    ? fmList.filter(fm => fm.lithostratTypeId === lithostratTypeId)
    : fmList;
  const sorted = R.sortBy(fm => fm.name, filtered);
  const options = sorted.map(fm => ({
    value: fm.id,
    label: fm.name,
    disabled: onlyPublished && !fm.wikiPage?.published,
  }));

  return (
    <FormikReactSelectField {...props} options={options} loading={loading} />
  );
}
